import React from 'react'
import { Box, Button, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
export default function LandingCard(props){
    return(
        <Paper
              sx={{
                padding: "20px 20px 3rem",
                display: "flex",
                flexDirection: "column",
                alignItq: "flex-start",
                borderRadius: "15px",
                height:"357px",
                ':hover': {
                  boxShadow: 20, // theme.shadows[20]
                },
              }}
              // elevation={props.elevation}
            >
              <Box
                component="img"
                src={props.img}
                sx={{ height: "138px", width: "138px", mb:"1.5rem" }}
              />
              <Typography
                sx={{
                  fontSize: "1.15rem",
                  fontWeight: "600",
                  textAlign: "left",
                  lineHeight: "23px",
                }}
              >
                {props.head}
              </Typography>
              <Typography
                sx={{
                  textAlign: "justify",
                  fontWeight: "500",
                  fontSize: "0.8rem",
                  lineHeight: "23px",
                }}
              >
                {props.content}
              </Typography>
            </Paper>
    );
}